export default {
  latest: {
    latitude: 0,
    longitude: 0
  },
  eta: {},
  directions: {},
  distanceToSite: {
    value: null,
    test: null
  }
}
